export default{
    setCookie(cname, cvalue, exdays) {  
        var d = new Date();  
        d.setTime(d.getTime() + (exdays*24*60*60*1000));  
        var expires = "expires="+d.toUTCString();  
        document.cookie = cname + "=" + cvalue + "; " + expires;  
    },
    getCookie(cname) {
        var name = cname + "=";  
        var ca = document.cookie.split(';');  
        for(var i=0; i<ca.length; i++) {  
            var c = ca[i];  
            while (c.charAt(0)==' ') c = c.substring(1);  
            if (c.indexOf(name) != -1) return c.substring(name.length, c.length);  
        }  
        return "";  
    },
    clearCookie(name){
        this.setCookie(name, "", -1)
    },
    // 登录储存cookie
    loginSetCookie(res){
        this.setCookie("token", res.token, 7)
        this.setCookie("userName", res.username, 7)     // 用户名
        this.setCookie("id", res.id, 7)                 // 用户id
        this.setCookie("type", res.type, 7)             // 登录类型
        this.setCookie("siteName", res.site_name, 7)    // 机构名称
        this.setCookie("ip", res.ip, 7)                 // ip



        // this.setCookie("is_ip", res.is_ip, 7)
        // this.setCookie("email", res.email, 7)
        // this.setCookie("exist_email", res.exist_email , 7)
        // this.setCookie("type",res.type,7)
        // this.setCookie("ipAdress",res.ip,7)
    },
    // 退出登录清除cookie
    logoutClearCookie(){
        this.clearCookie("token")
        this.clearCookie("userName")
        this.clearCookie("siteName")
        this.clearCookie("is_ip")
        this.clearCookie("email")
        this.clearCookie("exist_email")
        this.clearCookie("type")
        this.clearCookie("ipAdress")
        var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
        if (keys) {
            for (var i = keys.length; i--;) {
                document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString();//清除当前域名下的,例如：m.kevis.com
                // document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString();//清除当前域名下的，例如 .m.kevis.com
                // document.cookie = keys[i] + '=0;path=/;domain=kevis.com;expires=' + new Date(0).toUTCString();//清除一级域名下的或指定的，例如 .kevis.com
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/cookies.js